import { COMPRESSOR_FORM_PAGE_LINK } from "../constants/routingLinks";
import { OPEN_COMPRESSOR_FORM } from "../constants/actionTypes";

export const goToCompressorForm = (inputData, history) => async (dispatch) => {
    dispatch({ type: OPEN_COMPRESSOR_FORM, payload: inputData});
    history.push(COMPRESSOR_FORM_PAGE_LINK);
}